module.exports = __webpack_public_path__ + "img/chile_jjoo.ac840a15.jpg";